import { render, staticRenderFns } from "./coachHome.vue?vue&type=template&id=22b7ac2f&scoped=true&"
import script from "./coachHome.vue?vue&type=script&lang=js&"
export * from "./coachHome.vue?vue&type=script&lang=js&"
import style0 from "./coachHome.vue?vue&type=style&index=0&id=22b7ac2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b7ac2f",
  null
  
)

export default component.exports